<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:right_view>
      <div class="h-toolbarBg">
        <ejs-toolbar :items="toolbarItems"></ejs-toolbar>
        <div class='h-inputBox'>
          <ejs-textbox v-model='keyword' :placeholder='$t("Security.User.username")' @keyup.enter.native="filterAccount" maxLength='20'></ejs-textbox>
        </div>
      </div>
      <div class="h100-80 h-scroll">
        <ejs-grid :dataSource="accountData" :allowPaging="true" ref="grid" :pageSettings="pageSettings" :height="screenHeight" :allowExcelExport='true' :excelExportComplete='excelExportComplete'>
          <e-columns>
            <e-column type="checkbox" width="50" textAlign="center"></e-column>
            <e-column field="userId" :visible="false"></e-column>
            <e-column field="username" :headerText="$t('Security.User.username')" width="120" textAlign="Center"></e-column>
            <e-column field="realName" :headerText="$t('Security.User.realname')" width="120" textAlign="Center"></e-column>
            <e-column field="statusName" :headerText="$t('Security.User.status')" width="120" textAlign="Center"></e-column>
            <e-column field="timeoutStatusName" :headerText="$t('Security.User.timeoutstatus')" width="120" textAlign="Center"></e-column>
            <e-column field="createTime" :headerText="$t('Security.Role.createTime')" :format="dateFormat" width="120" textAlign="Center" clipMode="EllipsisWithTooltip"></e-column>
            <e-column field="loginTime" :headerText="$t('Security.Log.loginTime')" :format="dateFormat" width="120" textAlign="Center" clipMode="EllipsisWithTooltip"></e-column>
            <e-column field="description" :headerText="$t('Security.User.desc')" width="120" textAlign="Center" clipMode="EllipsisWithTooltip"></e-column>
          </e-columns>
        </ejs-grid>
        <ejs-pager
          ref="pager"
          :pageSize="pageSettings.pageSize"
          :pageCount="page.pageCount"
          :currentPage="page.pageNo"
          :totalRecordsCount="page.totalRecordsCount"
          @click="getAccountList"
        ></ejs-pager>
      </div>
      <CustomDialog
        ref="addAccountDialog"
        v-bind:element="addDialog.element"
        v-bind:styles="addDialog.styles"
      >
        <template v-slot:dialog-content>
          <AddAccount ref="addAccountPage" :index="addIndex"></AddAccount>
        </template>
      </CustomDialog>
      <CustomDialog
        ref="editAccountDialog"
        v-bind:element="editDialog.element"
        v-bind:styles="editDialog.styles"
      >
        <template v-slot:dialog-content>
          <EditAccount ref="editAccountPage"></EditAccount>
        </template>
      </CustomDialog>
      <CustomDialog
        ref="copyAccountDialog"
        v-bind:element="copyDialog.element"
        v-bind:styles="copyDialog.styles"
      >
        <template v-slot:dialog-content>
          <CopyAccount ref="copyAccountPage"></CopyAccount>
        </template>
      </CustomDialog>
      <CustomDialog ref='upload' :element='upload.element' :styles='upload.styles1'>
        <template v-slot:dialog-content>
          <AddDialog ref='addObj'></AddDialog>
        </template>
      </CustomDialog>

    </template>
  </BasicLayout>
</template>
<script>
import BasicLayout from '../../layouts/BasicLayout';
import CustomDialog from '../../components/common/CustomDialog';
import AddAccount from '../../components/security/accountManager/addAccount';
import EditAccount from '../../components/security/accountManager/editAccount';
import CopyAccount from '../../components/security/accountManager/copyAccount';
import {ExcelExport} from '@syncfusion/ej2-vue-grids';
import AddDialog from '../../components/system/ConfigInEx/addDialog';

import bus from '../../components/system/bus.js';
import { EventBus } from '../../plugins/eventBus';
let fileName ="";
export default {
  name: 'AccountManager',
  provide: {
    grid: [ExcelExport]
  },
  data() {
    return {
      accountData: [],
      left: { show: false, name: '' },
      middle: { show: false, name: '' },
      right: { show: true, crumb: `${this.$t('Security.securityManage')}`+'/' + `${this.$t('Security.authorityManage')}` + '/' + `${this.$t('Security.userManage')}` },
      toolbarItems: [
        { prefixIcon: 'icon hero-icon hero-icon-add', tooltipText: this.$t('Security.add'), click: this.showAddDialog },
        { prefixIcon: 'icon hero-icon hero-icon-groupmember', tooltipText: this.$t('Security.copyUser'), click: this.showCopyUser },
        { prefixIcon: 'icon hero-icon hero-icon-edit', tooltipText: this.$t('Security.modify'), click: this.showModifyDialog },
        { prefixIcon: 'icon hero-icon hero-icon-remove', tooltipText: this.$t('Security.delete'), click: this.deleteAccount },
        { prefixIcon: 'icon hero-icon hero-icon-business-operation', tooltipText: this.$t('Login.updPasswdTitle'), click: this.modifyPwdShow },
        { prefixIcon: 'icon hero-icon hero-icon-refresh', tooltipText: this.$t('Alarm.refresh'), click: this.refreshGrid },
        { prefixIcon: 'icon hero-icon hero-icon-synchronize', tooltipText: this.$t('Login.unlock'), click: this.unlock },
        { prefixIcon: 'icon hero-icon hero-icon-export' , tooltipText: this.$t('Alarm.export') ,click: this.exportGrid },
        { prefixIcon: 'icon hero-icon hero-icon-upload' , tooltipText: this.$t('DataManagent.import') ,click: this.importGrid }

      ],
      keyword: '',
      pageSettings: { pageSize: 15 },
      page: {
        pageCount: 4,
        totalRecordsCount: 0,
        pageNo: 1,
      },
      dateFormat: {
        type: 'date', format: 'yyyy/MM/dd HH:mm:ss'
      },
      addIndex: 0,
      editId: '',
      addStatus: true,
      addDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'addAccountDialog',
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t('Common.cancel')}` }
            },
            {
              click: this.prevAdd,
              buttonModel: {
                content: `${this.$t('Common.previous')}`,
                cssClass: 'h-security-display-none'
              }
            },
            {
              click: this.nextAdd,
              buttonModel: { content: `${this.$t('Common.next')}` }
            }
          ],
          title: `${this.$t('Security.addUser')}`
        },
        styles: {
          width: '810px',
          height: '650px',
          model: true,
          visible: false
        }
      },
      editDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'edit',
          title: `${this.$t('Security.editUser')}`,
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t('Common.cancel')}` }
            },
            {
              click: this.modifyAccount,
              buttonModel: { content: `${this.$t('Common.ok')}`, cssClass: 'primary-btn' }
            }
          ]
        },
        styles: {
          width: '810px',
          height: '650px',
          model: true,
          visible: false
        }
      },
      copyDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'copy',
          title: `${this.$t('Security.copyUser')}`,
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t('Common.cancel')}` }
            },
            {
              click: this.copyAccount,
              buttonModel: { content: `${this.$t('Common.ok')}`, cssClass: 'primary-btn' }
            }
          ]
        },
        styles: {
          width: '810px',
          height: '650px',
          model: true,
          visible: false
        }
      },
      upload: {
        styles: {
          width: '810px',
          height: '752px',
          model: true,
          visible: false
        },
        styles1: {
          width: '500px',
          height: '300px',
          model: true,
          visible: false
        },
        element: {
          refName: "detailLog",
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide1, buttonModel: { content: this.$t('DataManagent.import') } },
          ],
          title: this.$t('Security.uploadFile')
        },
      },
      screenHeight: document.body.clientHeight - 240
    };
  },
  components: {
    BasicLayout,
    CustomDialog,
    AddAccount,
    EditAccount,
    CopyAccount,
    AddDialog
  },
  mounted() {
    fileName ="";
    console.log("=====fileName===",fileName);
    bus.$on('selectNeData', (neNode) => {
      checkData = neNode;
    });

     bus.$on('fileName', (neNode) => {
           console.log("=====neNode===",neNode);
       fileName = neNode;
    });
    this.getAccountList();
    let That = this;
    window.onresize = () => {
      return (() => {
        That.screenHeight = document.body.clientHeight - 240;
      })()
    }
  },
  methods: {
    getAccountList() {
      const url = '/lte/ems/user/query';
      this.page.pageNo = this.$refs.pager.ej2Instances.currentPage;
      const params = { params: {
        username: this.keyword,
        pageNo: this.page.pageNo,
        pageSize: this.pageSettings.pageSize
      } };
      const That = this;
      this.axios.get(url, params).then(response => {
        const result = response.data.result;
        result.forEach((v) => {
          let date = new Date();
          if (!!v.createTime) {
            date.setTime(v.createTime);
            v.createTime = date;
          }
          if (!!v.loginTime) {
            date = new Date();
            date.setTime(v.loginTime);
            v.loginTime = date;
          }
        });
        That.accountData = result;
        That.page.totalRecordsCount = response.data.totalCount;
        //删除 e-checkbox-disabled
        let boxCollection= document.getElementsByClassName("e-checkbox-disabled")
        console.log(boxCollection)
        if(boxCollection.length>0){
          boxCollection[0].classList.remove("e-checkbox-disabled")
        }

      });
    },
    filterAccount() {
      this.getAccountList();
    },

    getRecord() {
      const result = this.$refs.grid.getSelectedRecords();
      if (result === null || result === '') {
        this.$parent.showToast('warning',`${this.$t('Common.tips.noSelect')}`);
        return null;
      }
      return result;
    },
    showAddDialog() {
      this.$refs.addAccountPage.init();
      this.$refs.addAccountDialog.show();
    },
    showModifyDialog() {
      const record = this.getRecord();
      if (record.length === 0) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.selectOne')}`);
        return null;
      }
      if (record.length !== 1) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.onlyOneSelect')}`);
        return null;
      }
      this.editId = record[0].userId;
      this.$refs.editAccountPage.findEditAccount(this.editId);
      this.$refs.editAccountDialog.show();
    },
    deleteAccount() {
      let isEadmin = false;
      const record = this.getRecord();
      if (record.length === 0) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.selectOne')}`);
        return null;
      }

      const url = '/lte/ems/user/delete';
      const params = [];
      record.forEach((r, i) => {
        if(r.username != 'Eadmin'){
           params.push(r.userId);
        }else{
          isEadmin = true;
           this.$parent.showToast('warning',`${this.$t('Security.User.forbidenDel')}`);
        }
      });
      if(!isEadmin){
        let That = this;
        this.$layer.confirm({
        msg: `${this.$t('Common.tips.confirmTip')}`,
        btn1: {
          msg: `${this.$t('Common.cancel')}`
        },
        btn2: {
          msg: `${this.$t('Common.ok')}`,
          func: () => {
            That.axios.post(url, params).then(response => {
              if (response.data) {
                That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
                That.getAccountList();
              } else {
                That.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
              }
            });
          }
        }
        });
      }

    },
    addAccount() {
      if (this.addStatus) {
        this.addStatus = false;
        const url = '/lte/ems/user/add';
        const accountInfo = this.$refs.addAccountPage.getAddInfo();
        if(accountInfo == null) {
          this.addStatus = true;
          return;
        }
        let That = this;
        this.axios.post(url, accountInfo).then(response => {
          const result = response.data;
          if(result) {
            That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
            That.getAccountList();
          } else {
            That.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
          }
          That.addIndex = 0;
          That.addStatus = true;
          That.$refs.addAccountDialog.clear();
          That.$refs.addAccountDialog.close();
        });
      }
    },
    modifyAccount() {
      const url = '/lte/ems/user/edit';
      const accountInfo = this.$refs.editAccountPage.getEditInfo();
      if(accountInfo == null) {
        return;
      }
      let That = this;
      this.axios.post(url, accountInfo).then(response => {
        const result = response.data;
        if(result) {
          That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
          That.getAccountList();
        } else {
          That.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
        }
        That.$refs.editAccountDialog.clear();
        That.$refs.editAccountDialog.close();
      });
    },
    dialogHide() {
      this.addIndex = 0;
      this.$refs.addAccountDialog.clear();
      this.$refs.addAccountDialog.close();
      this.$refs.editAccountDialog.clear();
      this.$refs.editAccountDialog.close();
      this.$refs.copyAccountDialog.clear();
      this.$refs.copyAccountDialog.close();
    },
    modifyPwdShow() {
      let record = this.getRecord();
      if (record.length === 0) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.selectOne')}`);
        return null;
      }
      if (record.length !== 1) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.onlyOneSelect')}`);
        return null;
      }
      this.$parent.updPwdAccountId = record[0].userId;
      this.$parent.$refs.pwdDialog.show();
      this.$parent.$refs.modiyPwd.initStrategy();
    },
    refreshGrid() {
      this.keyword='';
      this.getAccountList();
    },
    copyDeep(templateData) {
      const returnData = JSON.parse(JSON.stringify(templateData));
      returnData.buttonGroup.forEach((item, index) => {
        item.click = templateData.buttonGroup[index].click;
      });
      return returnData;
    },
    prevAdd() {
      if (this.addIndex !== 0) {
        this.addIndex -= 1;
      }
    },
    nextAdd() {
      if (this.addIndex === 2) {
        this.addAccount();
      } else if (this.addIndex === 0) {
        let status = this.$refs.addAccountPage.validation();
        if (status) {
          this.addIndex += 1;
        }
      } else {
        this.addIndex += 1;
      }
    },
    showCopyUser() {
      let record = this.getRecord();
      if (record.length === 0) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.selectOne')}`);
        return null;
      }
      if (record.length !== 1) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.onlyOneSelect')}`);
        return null;
      }
      this.editId = record[0].userId;
      this.$refs.copyAccountPage.findCopyAccount(this.editId);
      this.$refs.copyAccountDialog.show();
    },
    copyAccount() {
      this.addStatus = false;
      const url = '/lte/ems/user/add';
      const accountInfo = this.$refs.copyAccountPage.getEditInfo();
      if(accountInfo == null) {
        this.addStatus = true;
        return;
      }
      let That = this;
      this.axios.post(url, accountInfo).then(response => {
        const result = response.data;
        if(result) {
          That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
          That.getAccountList();
        } else {
          That.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
        }
        That.addIndex = 0;
        That.addStatus = true;
        That.$refs.copyAccountDialog.clear();
        That.$refs.copyAccountDialog.close();
      });
    },
    unlock() {
      const record = this.getRecord();
      if (record.length === 0) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.selectOne')}`);
        return null;
      }
      if (record.length !== 1) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.onlyOneSelect')}`);
        return null;
      }
      if (record[0].timeoutStatus == 0) {
        this.$parent.showToast('warning',`${this.$t('Login.unlocked')}`);
        return null;
      }
      const url = '/lte/ems/user/unlock';
      const params = {
        username: record[0].username
      } ;
      this.axios.post(url, params).then(response => {
        if (response.data) {
          this.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
          this.getAccountList();
        } else {
          this.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
        }
      });
    },
// 导入excel
    eventEmit(type, content) {
        EventBus.$emit('toast', {type: type, content: content})
        },
    dialogHide1() {
      if(fileName ==""||fileName == undefined){
          this.eventEmit('warning', this.$t('System.fileNotNull'));
           return;
      }
      let index = fileName.lastIndexOf(".");
      let fileType = fileName.substring(index+1).toLocaleLowerCase();

      if(fileType !='xlsx'){
        this.eventEmit('warning', this.$t('Security.fileTypeError'));
        return;
      }

      if(this.uploadProps.status == 1){
        this.$loading.showLoadding(this.$t('Software.progressing'));
        const url = '/lte/ems/role/importAuth';
        const param = {
          fileName: fileName
        };
        this.$axios.post(url, param).then(response => {
          this.$loading.hideLoadding();
          fileName = "";
          if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
             EventBus.$emit('toast', {type: 'warn', content:this.$t('MCS.importSuccess') });
            // let checkResult = response.data.resultVal;
            // if(checkResult){
            //   EventBus.$emit('toast', {type: 'warn', content:this.$t('System.batchInitNECfgCheckSuccess') });
            // }else{
            //   EventBus.$emit('toast', {type: 'warn', content:this.$t('System.batchInitNECfgCheckFail') });
            // }
          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        });
        this.$refs.upload.clear();
        this.$refs.upload.close();
      }else{
          this.$layer.confirm({
          title: this.$t('System.tip'),
          msg: this.$t('DeployManagement.tips_cancelUpload'),
          btn2: {
            msg: this.$t('System.confirm'),
            func: () => {
                this.$refs.upload.clear();
                this.$refs.upload.close();
            }
          },
          btn1: {
            msg: this.$t('System.cancel')
          }
        });
      }
    },
    getCheckedData(selectOnly) {
      // false: 不支持多选   true: 支持多选
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        // EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.no_checked')});
        // this.$parent.showToast('warning',`${this.$t('Alarm.no_checked')}`);

        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        // EventBus.$emit('toast', {type: 'warning', content: this.$t('Common.tips.onlyOneSelect')});
        this.$parent.showToast('warning',`${this.$t('Common.tips.onlyOneSelect')}`);
        return false;
      }
      return selectedRecords;
    },
    exportGrid1(){
      const This = this;
      const checkedData = This.getCheckedData(true);
      if (checkedData) {
        const exportProperties = {
          fileName: `${this.$t('Security.userManage')}.xlsx`,
          dataSource: checkedData
        };
        This.$refs.grid.getColumns()[0].visible = false;
        This.$refs.grid.excelExport(exportProperties);
      }
    },
    exportGrid(){
      const rows = this.getCheckedData(true);
          // if(rows.length ===0){
          //   this.$parent.showToast('warning',  `${this.$t('Alarm.no_checked')}`);
          // }
          this.exportData(rows);
    },
    exportData(rows){
      const param = {
        "path":"/home/",
        "fileNames":"用户管理.xlsx"
      }
      //  const data = JSON.parse(param);
      axios({
        method: 'post',
        url: '/lte/ems/role/export',
        data: param,
        responseType: 'blob'
        }).then(response => {
        const link = document.createElement('a');
        const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        let fileNames = response.headers['content-disposition'] //获取到Content-Disposition;filename
        console.log("fileNames",fileNames)
        let regFileNames = fileNames.match(/=(.*)$/)[1]; //文件名称  截取=后面的文件名称

        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", regFileNames);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        })
      },
    importGrid(){
      this.uploadProps = {status: 1};
      this.$refs.upload.show();
    },
    excelExportComplete() {
      this.$refs.grid.getColumns()[0].visible = true;
    },
  },

  beforeDestroy() {
    bus.$off('selectNeData');
    bus.$off('fileName');
  },

  watch: {
    addIndex() {
      const temp = this.copyDeep(this.addDialog.element);
      if (this.addIndex === 2) {
        temp.buttonGroup[2].buttonModel.content = `${this.$t('Common.ok')}`;
        temp.buttonGroup[2].buttonModel.cssClass = 'primary-btn';
      } else {
        temp.buttonGroup[2].buttonModel.content = `${this.$t('Common.next')}`;
        temp.buttonGroup[2].buttonModel.cssClass = '';
      }
      if (this.addIndex === 0) {
        temp.buttonGroup[1].buttonModel.cssClass = 'h-security-display-none';
      } else {
        temp.buttonGroup[1].buttonModel.cssClass = 'h-security-display-block';
      }
      this.addDialog.element = temp;
    },
    screenHeight(val) {
      this.screenHeight = val;
    }
  }
};
</script>

<style scoped>

</style>
